/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderPlanTransportLot
 */
export interface OrderPlanTransportLot {
    /**
     * 
     * @type {number}
     * @memberof OrderPlanTransportLot
     */
    companyId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPlanTransportLot
     */
    centerId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderPlanTransportLot
     */
    orgSupplierId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OrderPlanTransportLot
     */
    recDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPlanTransportLot
     */
    transportLotNo?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderPlanTransportLot
     */
    itemCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderPlanTransportLot
     */
    orgItemCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPlanTransportLot
     */
    minLoadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPlanTransportLot
     */
    orderTransportTypeId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof OrderPlanTransportLot
     */
    orderDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPlanTransportLot
     */
    lotQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPlanTransportLot
     */
    weight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPlanTransportLot
     */
    maxPalletQuantity?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof OrderPlanTransportLot
     */
    orderDatePrev?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPlanTransportLot
     */
    lotQuantityPrev?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderPlanTransportLot
     */
    remarks?: string | null;
}

/**
 * Check if a given object implements the OrderPlanTransportLot interface.
 */
export function instanceOfOrderPlanTransportLot(value: object): value is OrderPlanTransportLot {
    return true;
}

export function OrderPlanTransportLotFromJSON(json: any): OrderPlanTransportLot {
    return OrderPlanTransportLotFromJSONTyped(json, false);
}

export function OrderPlanTransportLotFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPlanTransportLot {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'centerId': json['center_id'] == null ? undefined : json['center_id'],
        'orgSupplierId': json['org_supplier_id'] == null ? undefined : json['org_supplier_id'],
        'recDate': json['rec_date'] == null ? undefined : (new Date(json['rec_date'])),
        'transportLotNo': json['transport_lot_no'] == null ? undefined : json['transport_lot_no'],
        'itemCode': json['item_code'] == null ? undefined : json['item_code'],
        'orgItemCode': json['org_item_code'] == null ? undefined : json['org_item_code'],
        'minLoadCapacity': json['min_load_capacity'] == null ? undefined : json['min_load_capacity'],
        'orderTransportTypeId': json['order_transport_type_id'] == null ? undefined : json['order_transport_type_id'],
        'orderDate': json['order_date'] == null ? undefined : (new Date(json['order_date'])),
        'lotQuantity': json['lot_quantity'] == null ? undefined : json['lot_quantity'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'maxPalletQuantity': json['max_pallet_quantity'] == null ? undefined : json['max_pallet_quantity'],
        'orderDatePrev': json['order_date_prev'] == null ? undefined : (new Date(json['order_date_prev'])),
        'lotQuantityPrev': json['lot_quantity_prev'] == null ? undefined : json['lot_quantity_prev'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function OrderPlanTransportLotToJSON(json: any): OrderPlanTransportLot {
    return OrderPlanTransportLotToJSONTyped(json, false);
}

export function OrderPlanTransportLotToJSONTyped(value?: OrderPlanTransportLot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_supplier_id': value['orgSupplierId'],
        'rec_date': value['recDate'] == null ? value['recDate'] : value['recDate'].toISOString(),
        'transport_lot_no': value['transportLotNo'],
        'item_code': value['itemCode'],
        'org_item_code': value['orgItemCode'],
        'min_load_capacity': value['minLoadCapacity'],
        'order_transport_type_id': value['orderTransportTypeId'],
        'order_date': value['orderDate'] == null ? value['orderDate'] : value['orderDate'].toISOString(),
        'lot_quantity': value['lotQuantity'],
        'weight': value['weight'],
        'max_pallet_quantity': value['maxPalletQuantity'],
        'order_date_prev': value['orderDatePrev'] == null ? value['orderDatePrev'] : value['orderDatePrev'].toISOString(),
        'lot_quantity_prev': value['lotQuantityPrev'],
        'remarks': value['remarks'],
    };
}

